/** 保管庫ゼロ時のセットアップ導線（一覧／ケース → 保管庫） */

export const SAMPLE_STORAGE_SETUP_PATH = '/storage-rooms';
export const SAMPLE_STORAGE_SETUP_QUERY_KEY = 'setup';
export const SAMPLE_STORAGE_SETUP_QUERY_VALUE = '1';
export const SAMPLE_STORAGE_SETUP_HREF = `${SAMPLE_STORAGE_SETUP_PATH}?${SAMPLE_STORAGE_SETUP_QUERY_KEY}=${SAMPLE_STORAGE_SETUP_QUERY_VALUE}`;

/** 同一セットアップ訪問で新規モーダルを二重オープンしない（再誘導時はクリアする） */
export const SAMPLE_STORAGE_SETUP_MODAL_SESSION_KEY = 'sample-manager.storageSetup.modalOpened';

export function resolveStorageSetupRedirectPath(): string {
  return SAMPLE_STORAGE_SETUP_HREF;
}

/** ゲートから再誘導する直前に呼び、閉じたあとの再訪問でもモーダルを1回開けるようにする */
export function clearStorageSetupModalSession(): void {
  try {
    sessionStorage.removeItem(SAMPLE_STORAGE_SETUP_MODAL_SESSION_KEY);
  } catch {
    /* private mode 等 */
  }
}

export function isStorageSetupSearchParams(
  searchParams: URLSearchParams | { get: (key: string) => string | null }
): boolean {
  return searchParams.get(SAMPLE_STORAGE_SETUP_QUERY_KEY) === SAMPLE_STORAGE_SETUP_QUERY_VALUE;
}

/**
 * 読み込み中・エラー時は誘導しない（チラつき・誤誘導防止）。
 * total が 0 のときだけ true。
 */
export function shouldRedirectToStorageSetup(opts: {
  isReady: boolean;
  isError: boolean;
  total: number | undefined | null;
}): boolean {
  if (!opts.isReady || opts.isError) return false;
  if (opts.total == null || Number.isNaN(Number(opts.total))) return false;
  return Number(opts.total) === 0;
}

export function hasUsableStorageRooms(total: number | undefined | null): boolean {
  return typeof total === 'number' && !Number.isNaN(total) && total > 0;
}

/** ナビ／セクション選択用。保管庫0件なら保管タブも setup=1 へ */
export function resolveSampleManagerNavHref(
  path: string,
  opts: { isReady: boolean; hasStorageRooms: boolean }
): string {
  if (path === SAMPLE_STORAGE_SETUP_PATH && opts.isReady && !opts.hasStorageRooms) {
    return SAMPLE_STORAGE_SETUP_HREF;
  }
  return path;
}
